import * as Dialog from '@radix-ui/react-dialog';
import { Close } from '@/icons';
import { EmailMessage } from '@/illustrations';

type Props = {
  open: boolean;
  onOpenChange: (open: boolean) => void;
};

export function ThankYouModal({ open, onOpenChange }: Props) {
  return (
    <Dialog.Root open={open} onOpenChange={onOpenChange}>
      <Dialog.Portal>
        <Dialog.Overlay className="fixed inset-0 bg-bg/80 backdrop-blur-sm z-50 data-[state=open]:animate-in data-[state=open]:fade-in" />
        <Dialog.Content
          className="fixed left-1/2 top-1/2 z-50 w-[92vw] max-w-lg -translate-x-1/2 -translate-y-1/2 bg-surface border border-border-strong p-8 md:p-10 focus:outline-none"
        >
          <div className="flex justify-end">
            <Dialog.Close aria-label="Close" className="p-2 -m-2 hover:text-accent transition-colors cursor-pointer">
              <Close className="w-5 h-5" />
            </Dialog.Close>
          </div>
          <div className="flex flex-col items-center text-center gap-6 pb-4">
            <div className="w-40 h-40 text-ink-primary">
              <EmailMessage className="w-full h-full" />
            </div>
            <Dialog.Title className="font-display text-4xl font-medium">Thank you</Dialog.Title>
            <Dialog.Description className="text-ink-secondary max-w-sm leading-relaxed">
              Your message is on its way to the studio. We will come back to you within one business day, Cyprus time.
            </Dialog.Description>
            <p className="mono-meta text-ink-muted">
              Prefer a direct line? <a className="text-accent underline underline-offset-4" href="mailto:business@justsee-ltd.com">business@justsee-ltd.com</a>
            </p>
          </div>
        </Dialog.Content>
      </Dialog.Portal>
    </Dialog.Root>
  );
}
